import { atom } from "recoil";
export var panelOpenAtom = atom({
    key: "panelOpen",
    default: false,
});
